<template lang="pug">
  .root
    the-heading(:caption="caption" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .load(v-if="!dashboardsLoaded")
          v-icon(name="spinner" spin scale="4" style="margin-top: 150px; color: #ccc;")
        .load(v-if="!dashboardsLoaded" style='color: #ccc; font-size: 32px;')  {{startText}}
        iframe(v-if="dashboardsLoaded" :src="tableauSRC" style='width: 100%; min-height: 89vh; border: 0; margin-bottom:-1vh;' allowfullscreen)
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import axios from 'axios'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    TheHeading,
    'v-icon': Icon
  },
  data () {
    return {
      errors: {},
      caption: 'Информационная панель COVID-19',
      breadcrumbs: null,
      startText: 'Подождите, идет загрузка...',
      dashboardsLoaded: false,
      tableauSRC: ''
    }
  },
  mounted () {
    let tableauScript = document.createElement('script')
    tableauScript.setAttribute('src', '/javascripts/api/viz_v1.js')
    document.head.appendChild(tableauScript)
    this.getTableauParams()
  },
  methods: {
    getTableauParams () {
      axios
        .get('dhra/api/v2/integration/tableau/get-params/')
        .then(values => {
          this.tableauSRC = `${values.data.host_url}/${values.data.ticket}/views/${values.data.name}?:embed=yes`
          this.dashboardsLoaded = true
        })
        .catch(error => {
          this.dashboardsLoaded = false
          this.startText = 'Произошла ошибка. Пожалуйста, обратитесь в службу технической поддержки.'
          this.spinnerON = false
        })
        .finally(() => (this.spinnerON = false))
    }
  }
}
</script>
<style lang="sass" scoped>
.main_block
  min-height: 89vh
.localCaption
  margin-left: 40px
  margin-top: 50px
.load
  display: flex
  justify-content: center
  align-items: center
  min-height: 100px
.errData
  color: #e53935
  display: flex
  align-items: center
  justify-content:  center
@import "@/css/pageGridStyles.sass"
</style>
